import {cs}                     from "@Common/react/chain-services";
import {consumeContext}         from "@Common/react/context";
import {Load}                   from "@Common/react/load";
import {stateChangeNestedValue} from "@Common/react/state-change-nested-value";
import {UseState}               from "@Common/react/use-state";

export const BuildingSelector = ({next}) => cs(

    consumeContext("apis"),
    ["streetList", ({apis}, next) => Load({
        fetch: () => apis.next.mailing.decondo.getStreetNames(),
        next,
    })],
    ({streetList, apis}) => next({
        renderForm: ({next}) => cs(
            ["data", (_, next) => UseState({next})],
            ["buildingList", ({data}, next) => Load({
                _key: data.value?.street,
                fetch: async () => !data.value?.street ? null : await (async () => {
                    const result = await apis.next.mailing.decondo.getBuildings(data.value?.street);
                    if (result.result === "failure") {
                        return {error: result.errors.msg};
                    }
                    return {data: result};
                })(),
                next,
            })],
            ({data, buildingList}) => next({
                streets: streetList && Object.keys(streetList),
                isStreetSelected: (k) => k === data.value?.street,
                onSelectStreet: (k) => data.change((_) => ({
                    ..._,
                    street: k,
                    building: null,
                })),
                getStreetName: (k) => streetList[k],
                hasStreet: () => data.value?.street,

                buildings: buildingList?.data && Object.keys(buildingList.data),
                buildingsError: buildingList?.error,
                isBuildingSelected: (k) => k === data.value?.building,
                onSelectBuilding: (k) => stateChangeNestedValue(data, ["building"], () => k),
                getBuildingName: (k) => buildingList.data[k],

                clear: () => data.onChange(null),

                ready: data.value?.street && data.value.building,
                getValue: () => ({
                    street  : {
                        key: data.value.street,
                        name: streetList[data.value.street],
                    },
                    building: {
                        key: data.value.building,
                        name: buildingList.data[data.value.building],
                    },
                }),
            }),
        ),
    }),
);
